import { render, staticRenderFns } from "./Overlays.vue?vue&type=template&id=1919d1c4&"
import script from "./Overlays.vue?vue&type=script&lang=js&"
export * from "./Overlays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports